import React from "react";
import { Api } from "../../utils/api";
import Grid from "@material-ui/core/Grid";
import PaymentItemsGridComponent from "./payment_items_grid.component";

export class PaymentDetails extends React.Component {
  constructor() {
    super();
    this.api = new Api();
  }

  componentDidMount() {}

  render() {
    const payment = this.props.payment;
    const nextPayments = this.props.nextPayments;
    //console.log(nextPayments);

    return (
      <>
        <Grid md={12} style={{ alignItems: "left", marginTop: "20px" }}>
          <PaymentItemsGridComponent
            title={"Próxima cobrança"}
            canAdd={true}
            canEdit={true}
            canDelete={true}
            showInvoices={true}
            payment={payment}
            payments={nextPayments}
            canEditAmount={true}
          />
        </Grid>
      </>
    );
  }
}
